"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_API_HOST = void 0;
exports.SEGMENT_API_HOST = 'api.segment.io/v1';
//# sourceMappingURL=index.js.map